/**
 * Get targeted product for tealium click. Uses article ID from the data attribute in <article> element at root of product tile.
 *
 * @returns targeted product or undefined
 */
const getArticleFromList = (eventData, productSet) => {
    if (!eventData || (!eventData.currentTarget && !eventData.target)) {
        return undefined;
    }
    let element = eventData.currentTarget || eventData.target;
    let productIdValue;
    let elementFound = false;
    while (element.parentElement && !elementFound) {
        elementFound = element.tagName === 'ARTICLE';
        if (elementFound) {
            productIdValue = element.dataset.articlecode;
        }
        element = element.parentElement;
    }
    if (!productIdValue)
        return undefined;
    return productSet.find(({ articleCode, code }) => `${articleCode}` === `${productIdValue}` || `${code}` === `${productIdValue}`);
};
export default getArticleFromList;
//# sourceMappingURL=getArticleFromList.js.map